<template>
  <div class="UserMenu">
    <DropdownMenu :dropped.sync="isDropped">
      <div slot="label" class="UserMenu__Label_wr">
        <div class="UserMenu__Photo">
          <img
            v-if="photoUrl && !incognitoMode"
            :src="photoUrl"
            alt="user logo"
          />
          <img v-else src="./../static/no-auth.jpg" alt="user logo" />
        </div>
        <div class="UserMenu__Label">{{ displayName }}</div>
      </div>

      <div slot="dropdown" class="UserMenu__List">
        <button
          v-if="!isLoggedIn"
          class="UserMenu__List-Item"
          @click="handleSignIn()"
        >
          {{ $t("user_menu.sign_in") }}
          <i class="fa fa-fw fa-sign-in UserMenu__List-Icon"></i>
        </button>
        <button
          v-if="!isLoggedIn"
          class="UserMenu__List-Item"
          @click="goToSelectedSite('/register')"
        >
          {{ $t("register_page.register") }}
          <i class="fa fa-fw fa-user-plus UserMenu__List-Icon"></i>
        </button>
        <button
          v-if="isLoggedIn"
          class="UserMenu__List-Item"
          @click="signOut()"
        >
          {{ $t("user_menu.sign_out") }}
          <i class="fa fa-fw fa-sign-out UserMenu__List-Icon"></i>
        </button>

        <h6 class="UserMenu__List-Header">{{ $t("user_menu.settings") }}</h6>
        <button
          class="UserMenu__List-Item"
          @click="
            toggleSetting('evaluationInTitle');
            isDropped = false;
          "
        >
          {{ $t("user_menu.valuation") }}
          <i
            class="fa fa-fw fa-check UserMenu__List-Icon"
            v-if="evaluationInTitle === true"
          ></i>
        </button>
        <!-- toggleNightMOde -->
        <button
          class="UserMenu__List-Item"
          @click="
            toggleSetting('nightMode');
            isDropped = false;
          "
        >
          {{ $t("user_menu.night_mode") }}
          <!-- Night mode -->
          <i class="fa fa-fw fa-check UserMenu__List-Icon" v-if="nightMode"></i>
        </button>

        <button
          class="UserMenu__List-Item"
          @click="
            toggleSetting('incognitoMode');
            isDropped = false;
          "
        >
          {{ $t("user_menu.incognito") }}
          <i
            class="fa fa-fw fa-check UserMenu__List-Icon"
            v-if="incognitoMode === true"
          ></i>
        </button>

        <!--
        <button
          v-if="isLoggedIn"
          class="UserMenu__List-Item"
          @click="goToSelectedSite('/exchange/apikeys')"
        >
          {{ $t("exchange.your_api_keys") }}
          <i class="fa fa-fw fa-key UserMenu__List-Icon"></i>
        </button>
        -->

        <button class="UserMenu__List-Item mt-3" @click="shareLink">
          {{ $t("user_menu.share_link") }}
        </button>
      </div>
    </DropdownMenu>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DropdownMenu from "./DropdownMenu";

export default {
  name: "UserMenu",
  components: {
    DropdownMenu,
  },
  data() {
    return {
      isDropped: false,
    };
  },
  computed: {
    ...mapGetters({
      evaluationInTitle: "settings/evaluationInTitle",
      nightMode: "settings/nightMode",
      incognitoMode: "settings/incognitoMode",
      isLoggedIn: "auth/isLoggedIn",
      displayName: "auth/displayName",
      photoUrl: "auth/photoUrl",
    }),
  },
  watch: {
    nightMode: {
      immediate: true,
      handler(value) {
        this.nightMode_changed(value);
      },
    },
  },
  methods: {
    handleSignIn() {
      this.toggleDialog("signIn", true);
      this.isDropped = false;
    },
    signOut() {
      this.logout();
      this.goToSelectedSite("/");
    },
    shareLink() {
      this.toggleDialog("share", true);
      this.isDropped = false;
    },
    nightMode_changed(value) {
      if (value) {
        document.body.classList.add("night");
      } else {
        document.body.classList.remove("night");
      }
    },
    goToSelectedSite(site) {
      this.isDropped = false;
      this.$router.push(site);
    },
    ...mapActions({
      toggleSetting: "settings/toggleSetting",
      toggleDialog: "ui/toggleDialog",
      logout: "auth/logout",
    }),
  },
};
</script>

<style lang="scss">
@import "~@/scss/variables";
@import "~@/scss/mixins";

.UserMenu {
  display: inline-block;
  font-size: 16px;
  margin-right: 0rem;
  .DropdownMenu {
    margin-right: 0;
  }
}

.UserMenu__Label_wr {
  display: flex;
  align-items: center;
}

.UserMenu__Photo {
  margin-right: 8px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #fff;
  background: #fff;
  flex-shrink: 0;
  img {
    height: 32px;
    width: 32px;
  }

  @include breakpoint-manual(max-width, $break-extra-small - 1px) {
    margin-right: -2px;
  }
}

.UserMenu__Label {
  color: #fff;
  display: inline-block;

  @include breakpoint-manual(max-width, $break-extra-small - 1px) {
    display: none;
  }
}

.UserMenu__List {
  width: auto;
}

.UserMenu__List-Header {
  color: #777;
  font-weight: 700;
  font-size: 15px;
  display: block;
  padding: 10px 20px 2px;
  margin: 18px 0 5px;
}

.UserMenu__List-Item {
  display: flex;
  margin-right: 10px;
  justify-content: space-between;
  cursor: pointer;
  white-space: nowrap;
  padding: 5px 20px;
  // display: block;
  color: #222;
  text-decoration: none;
  border: 0;
  background: none;
  width: 100%;
  text-align: left;
  font-size: 16px;
  transition: background 0.1s;

  &:hover {
    color: $color-secondary;
    background: #f4f4f4;
  }
}

.UserMenu__List-Icon {
  float: right;
  margin: 3px 0 0;
}
</style>
